var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React from "react";
import { observer } from "mobx-react";
import { mobx } from "@al/aku-lc-core";
import { each, isBool, isPlainObj } from "@al/aku-lc-helpers";
var transformProps = function (componentProps) {
    var props = {};
    mobx.keys(componentProps).forEach(function (key) {
        if (isPlainObj(componentProps[key])) {
            props[key] = transformProps(mobx.observable(componentProps[key]));
        }
        props[key] = componentProps[key];
    });
    return props;
};
function ReactiveWidgetImpl(props) {
    // const options = useContext(CreateRootContext);
    if (!props.widget) {
        return React.createElement(React.Fragment, null, props.children);
    }
    var widget = props.widget;
    var component = widget.component;
    // mobx proxy workaround
    var componentProps = transformProps(widget.componentProps);
    // if (options?.widgets) {
    //   component = options.widgets[widget.component];
    // }
    if (!widget.component) {
        return null;
    }
    // TODO: modal 如果 visible false 的时候，返回 null，导致没有动画
    if (isBool(widget.visible) && !widget.visible) {
        return null;
    }
    if (isBool(widget.hidden) && widget.hidden) {
        return null;
    }
    var renderDecorator = function (children) {
        var _a;
        if (!widget.decorator) {
            return React.createElement(React.Fragment, null, children);
        }
        return React.createElement(widget.decorator, __assign(__assign({}, transformProps(widget.decoratorProps)), { style: __assign({}, transformProps(mobx.observable(((_a = widget.decoratorProps) === null || _a === void 0 ? void 0 : _a.style) || {}))) }), children);
    };
    var renderComponent = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (!component) {
            return React.createElement(React.Fragment, null, props.children);
        }
        var value = widget.value;
        var onChange = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            widget.onInput.apply(widget, args);
            (_a = componentProps === null || componentProps === void 0 ? void 0 : componentProps.onChange) === null || _a === void 0 ? void 0 : _a.call.apply(_a, __spreadArray([componentProps], args));
        };
        var onFocus = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            widget.onFocus.apply(widget, args);
            (_a = componentProps === null || componentProps === void 0 ? void 0 : componentProps.onFocus) === null || _a === void 0 ? void 0 : _a.call.apply(_a, __spreadArray([componentProps], args));
        };
        var onBlur = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            widget.onBlur.apply(widget, args);
            (_a = componentProps === null || componentProps === void 0 ? void 0 : componentProps.onBlur) === null || _a === void 0 ? void 0 : _a.call.apply(_a, __spreadArray([componentProps], args));
        };
        var onClick = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            widget.onClick.apply(widget, args);
            (_a = componentProps === null || componentProps === void 0 ? void 0 : componentProps.onClick) === null || _a === void 0 ? void 0 : _a.call.apply(_a, __spreadArray([componentProps], args));
        };
        var trackingProps = {};
        var trackingPropKeyMapping = {
            click: (_c = (_b = (_a = widget.env) === null || _a === void 0 ? void 0 : _a.eventTracking) === null || _b === void 0 ? void 0 : _b.propKey) === null || _c === void 0 ? void 0 : _c.click,
            input: (_f = (_e = (_d = widget.env) === null || _d === void 0 ? void 0 : _d.eventTracking) === null || _e === void 0 ? void 0 : _e.propKey) === null || _f === void 0 ? void 0 : _f.input,
            expose: (_j = (_h = (_g = widget.env) === null || _g === void 0 ? void 0 : _g.eventTracking) === null || _h === void 0 ? void 0 : _h.propKey) === null || _j === void 0 ? void 0 : _j.expose,
        };
        if ((_k = widget.pluginData) === null || _k === void 0 ? void 0 : _k.tracking) {
            each(transformProps(widget.pluginData.tracking) || {}, function (value, k) {
                var key = trackingPropKeyMapping[k];
                if (key) {
                    trackingProps[key] = JSON.stringify(transformProps(value));
                }
            });
        }
        return React.createElement(component, __assign(__assign(__assign({}, componentProps), trackingProps), { style: __assign({}, transformProps(mobx.observable(((_l = widget.componentProps) === null || _l === void 0 ? void 0 : _l.style) || {}))), visible: widget.visible, hidden: widget.hidden, 
            // dataSource: widget.dataSource,
            loading: widget.loading, required: widget.required, disabled: widget.disabled, editable: widget.editable, readOnly: widget.readOnly, value: value, onClick: onClick, onChange: onChange, onFocus: onFocus, onBlur: onBlur }), props.children);
    };
    return renderDecorator(renderComponent());
}
export var ReactiveWidget = observer(ReactiveWidgetImpl);
